import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { PostHogProvider } from 'posthog-js/react'
import HyperDX from '@hyperdx/browser';
import App from './App.tsx'
import './index.css'

HyperDX.init({
  apiKey: 'b73f8570-9b73-49e0-9100-e40bc9e92711',
  url: 'https://trace.kphone.org',
  service: 'app-store',
  consoleCapture: true,
  advancedNetworkCapture: true,
});

const posthogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
}

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);
root.render(
  <StrictMode>
    <PostHogProvider 
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY} 
      options={posthogOptions}
    >
      <App />
    </PostHogProvider>
  </StrictMode>
);
